import { useEffect, useState } from "react";

const navLinks = [
  { label: "今日热搜", href: "#hot" },
  { label: "投票打榜", href: "#poll" },
  { label: "舞台直拍", href: "#stage" },
  { label: "热议八卦", href: "#gossip" },
  { label: "导师点评", href: "#mentor" },
  { label: "淘汰内幕", href: "#eliminate" },
  { label: "关于本站", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b border-background-300/70 transition-colors ${
        scrolled || open ? "bg-background-50/95 backdrop-blur" : "bg-background-50"
      }`}
    >
      <div className="container-x">
        <div className="flex items-center justify-between gap-4 py-3">
          {/* brand */}
          <a href="#top" className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-primary-600 text-lg font-bold text-background-50 shadow-none">
              <i className="ri-megaphone-fill" aria-hidden="true" />
            </span>
            <span className="leading-none">
              <span className="block font-serif text-xl font-black tracking-tight text-foreground-950 md:text-2xl">
                每日大赛
              </span>
              <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.24em] text-primary-600">
                DailyContest · 吃瓜打榜站
              </span>
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="relative whitespace-nowrap px-3 py-2 text-[13px] font-semibold text-foreground-700 transition-colors hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              className="ml-2 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-[13px] font-bold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-send-plane-fill" aria-hidden="true" />
              投稿线索
            </a>
          </nav>

          {/* mobile actions */}
          <div className="flex items-center gap-2 lg:hidden">
            <a
              href="#contact"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-600 px-3 py-2 text-xs font-bold text-background-50 hover:bg-primary-700"
            >
              投稿
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-600"
            >
              <i className={`text-lg ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <nav className="border-t border-background-200 lg:hidden" aria-label="移动端导航">
          <div className="container-x grid gap-1 py-3">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-semibold text-foreground-800 hover:bg-background-100 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}